import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"
import { IListaDadosHistoricoFreeAgency } from "../freeAgency/FreeAgencyService";
import { IListaDadosHistoricoLeilao } from "../leilao/LeilaoService";
import { IDetalhePropostas } from "../propostas/PropostaService";
//import { UtilidadeService } from "../utilidades/UtilidadesService";


export const lstStatus = [
    {
        codigo: 1,
        label: "Não Publicada"
    },
    {
        codigo: 2,
        label: "Publicada"
    },
    {
        codigo: 3,
        label: "Completa"
    }
];

export const BoxScore = [
    {
        codigo: 1,
        label: "(FGM) Qtde. Arremeso Marcado"
    },
    {
        codigo: 2,
        label: "(FG%) % Arremeso Marcado"
    },
    {
        codigo: 3,
        label: "(FTM) Lance Livre Marcado"
    },
    {
        codigo: 4,
        label: "(FT%) % Lance Livre Marcado"
    },
    {
        codigo: 5,
        label: "(3PM) Bolas de 3 Marcado"
    },
    {
        codigo: 6,
        label: "(3P%) % Bolas de 3 Marcado"
    },
    {
        codigo: 7,
        label: "(PTS) Pontos",
    },
    {
        codigo: 8,
        label: "(REB) Rebotes"
    },
    {
        codigo: 9,
        label: "(OREB) Rebotes Ofensivos"

    }, {
        codigo: 10,
        label: "(DREB) Rebotes Defensivos"
    },
    {
        codigo: 11,
        label: "(AST) Assistências"
    },
    {
        codigo: 12,
        label: "(STL) Roubada de Bola"
    },
    {
        codigo: 13,
        label: "(BLK) Bloqueios"
    }, {
        codigo: 14,
        label: "(TO) Turnovers"
    }, {
        codigo: 15,
        label: "(PF) Faltas"
    }, {
        codigo: 16,
        label: "(MPLU) Min_Plus"
    }, {
        codigo: 17,
        label: "(M) Minutos"
    }
];

export interface IDadosSaveLiga {
    codigo?: number
    nome: string;
    quantidade_Franquia: number;
    tipo: number;
    status: number;
    restrito: boolean;
    bloqueio_Maximo_Multa: boolean;
    primeira_Temporada: boolean;
    porcentagem_Bloqueio_Maximo_Multa?: string | null;
    logo: string;
    caminho_Logo: string;
    codUsuCriacao: number;
    codUsuModificacao?: number;
    separar_Multa_Temporada: number;
    configuracao_Liga: {
        codigo_Temporada: number;
        codigo_Tipo_Pontuacao: number;
        cap: string;
        situacao: boolean;
        num_Max_Jogadores: number;
        num_Min_Jogadores: number;
        cap_Minimo: string;
        cap_Maximo: string;
        aceita_Empate: boolean; //Aba jogo
        minimo_Jogadores_Escalacao: number;
        maximo_Jogadores_Escalacao: number;
        quantidade_Rodada_Draft: number;
        incluir_Calouros: boolean;
        salarios_Reais_NBA: boolean;
        first_Propria: boolean;
        min_First_Tempo: number;
        min_Posicao: number;
        max_Posicao: number;
        retorno_Jogador: number;
        retorno_Jogador_Dispensado: number;
        codigo_Tipo_Posicao_Confronto: number;
        bloquear_Calouro_Primeira_Rodada: boolean;
        bloquear_Calouro_Segunda_Rodada: boolean;
    },
    codigos_Comissarios?: number[],
    codigos_Gms?: number[],
    usuario_Comissario?: IDadosComissarios[],
    usuario_General_Manager?: IDadosGeneralManager[],
    configuracao_Disputa?: IDadosMetodo[],
    criterio_Desempate: IDadosEmpate[],
    regra_Desempate_Classificacao: IDadosRegraDesempate[],
    picks_Rodada_Inicial?: IDadosDraftNao[],
    draft_Salario?: IDadosDraftCalouros[],
    free_Agency: {
        codigo?: number;
        intervalo_Lance_Minimo: string;
        tempo_Duracao: number;
        tempo_Restrito: number;
        porcentagem_Aumento: string;
    },
    configuracao_Contusao: {
        automatico: boolean;
        autoriza_Contratacao: boolean;
        libera_Slote: boolean;
        porcentagem: string;
        temporada: boolean;
    },
    limites_Troca_Posicao: IConfiguracao_troca_posicao[],
    configuracao_Salario: IDadosDuracao[],
    configuracao_Multas: IConfiguracao_multas_Liga[],
    posicao_Conversao: [{
        posicao_Original: string;
        posicao_Liga: string
    }],
    salarios_NBA_Porcentagem: IDadoDraftSim[]
    atualizar_Configuracao_Disputa: boolean;
    atualizar_Configuracao_Multas: boolean;
    atualizar_Configuracao_Salario: boolean;
    atualizar_BonusCAP_Jogadores: boolean;
    atualizar_Salarios_NBA_Porcentagem: boolean;
    atualizar_Posicao_Conversao: boolean;
    atualizar_Picks_Rodada_Inicial: boolean;
    atualizar_Limites_Troca_Posicao: boolean;
    atualizar_Draft_Salario: boolean;
    atualizar_Criterio_Desempate: boolean;
    atualizar_Configuracao_Player_Option: boolean;
    atualizar_Regra_Desempate_Classificacao: boolean;

    bonusCAP_Liga?: {
        all_Star_Liga_First?: string;
        all_Star_Liga_Second?: string;
        calouros_Liga?: string;
        campeao_Conferencia_Liga?: string;
        campeao_Divisao_Liga?: string;
        campeao_Liga?: string;
        data_Votacao?: Date;
        dpoy_Liga?: string;
        dtCriacao?: Date;
        minimo_Jogos?: string;
        gm_Liga?:string;
        minimo_Minutos?: string;
        mvp_Liga?: string;
        playoffs_Liga?: string;
        roy_Liga?: string;
        semifinalista_Liga?: string;
        terceiro_Divisao_Liga?: string;
        treinador_Liga?: string;
        vice_Campeao_Liga?: string;
        vice_Conferencia_Liga?: string;
        vice_Divisao_Liga?: string;
        votacao: boolean;
        metodo_Configuracao_Jogador?: number;
    },
    bonusCAP_NBA?: {
        all_Star_NBA_First?: string;
        all_Star_NBA_Second?: string;
        calouros_NBA?: string;
        campeao_Conferencia_NBA?: string;
        campeao_Divisao_NBA?: string;
        campeao_NBA?: string;
        dpoy_NBA?: string;
        dtCriacao?: Date;
        mvp_NBA?: string;
        playoffs_NBA?: string;
        roy_NBA?: string;
        semifinalista_NBA?: string;
        terceiro_Divisao_NBA?: string;
        vice_Campeao_Divisao_NBA?: string;
        vice_Campeao_NBA?: string;
        vice_Conferencia_NBA?: string;

    },
    bonusCAP_Jogadores?: [{
        codUsuCriacao?: number;
        codigo?: number;
        codigo_Liga?: number;
        codigo_Temporada?: number;
        dtCriacao?: string;
        boxScore: number;
        inicio_Intervalo: number;
        fim_Intervalo: number;
        classificacao: number;
        valor: string;
        minimo_Jogos: number;
        minimo_Minutos: number;
        considera_Liga: boolean;
    }],
    configuracao_Free_Agency?: {
        codigo?: number;
        ano_Adicional_Direito_Jogador?: number;
        ano_Adicional_Restrito_Jogador?: number;
        desconto_Renovacao_Direito?: string | null;
        desconto_Renovacao_Draftado?: string | null;
        desconto_Renovacao_Restrito?: string | null;
        porcentagem_Contrato_Ajustavel?: string | null;
        tipo_Contrato_Ajustavel?: number | null;
        tipo: number;
        resetar_Bloqueio_Franquia: boolean;
        resetar_Posicao_Jogadores: boolean;
        divisao_Lote: boolean;
        player_Option: boolean;
        team_Option: boolean;
        match_Desconto: boolean;
        lance_Desconto_Restrito: boolean;
        lance_Desconto_Direito: boolean;
        cobrir_Temporada: boolean;
        cobrir_Temporada_Direito: boolean;
        sign_Trade: boolean;
        atualizar_Intervalo_Lance_Free_Agency: boolean;
        atualizar_Tempo_Periodo_Free_Agency: boolean;
        tempo_Periodo_Free_Agency: ITempo_Periodo_Free_Agency[],
        codigo_Opcao_Direito?: number,
        quantidade_Ano_Regressivo_Direito?: number,
        quantidade_Ano_Partir_Direito?: number,
        codigo_Opcao_Sem_Direito?: number,
        quantidade_Ano_Regressivo_Sem_Direito?: number,
        quantidade_Ano_Partir_Sem_Direito?: number,
        two_Way: boolean;
        tempo_Contrato_Maximo_Two_Way?: number | null;
        valor_Contrato_Maximo_Two_Way?: number | null;
        quantidade_Jogos_Maximo_Two_Way?: number | null;
        quantidade_Jogadores_Maximo_Two_Way?: number | null;
        incluir_Calouro_Two_Way: boolean;
        codigo_Tipo_Desconto_Restrito?: number
    }
    configuracao_Player_Option?: [{
        codigo?: number;
        codigo_Item_Player_Option: number;
        pontuacao: number;
        quantidade_Jogos?: number;
        repetir: boolean;
    }]
}

export interface IDadosPlayerOption {
    codigo_Item_Player_Option: number;
    pontuacao: number;
    quantidade_Jogos?: number | null;
    repetir: boolean;
}

export interface IIntervalo_Lance_Free_Agency {
    valor_Minimo?: number;
    valor_Maximo?: number;
    aumento_Minimo?: number;
}

export interface ITempo_Periodo_Free_Agency {
    tempo_Final_Lance?: number;
    tempo_Restrito_Aprovacao?: number;
    periodo_Horas?: number;
}

export interface IConfiguracao_multas_Liga {
    codUsuCriacao?: number;
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    dtCriacao?: string;
    porcentagem: string;
    valor_Maximo: string;
    valor_Minimo: string;

}

export interface IBonusCapJogadores {
    codUsuCriacao?: number;
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    dtCriacao?: string;
    boxScore: number;
    inicio_Intervalo: number;
    fim_Intervalo: number;
    classificacao: number;
    valor: string;
    minimo_Jogos: number;
    minimo_Minutos: number;
    considera_Liga: boolean;
}

export interface IConfiguracao_posicao_confronto {
    codUsuCriacao?: number;
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    dtCriacao?: string;
    posicao_Original?: string;
    posicao_Liga: string;

}

export interface IConfiguracao_troca_posicao {
    codigo_Temporada: number;
    tempo_Minimo: number;
    porcentagem: number;
}

export interface IDadosMultas_Liga {
    codigo: number;
    porcentagem: number;
    valor_Maximo: string;
    valor_Minimo: string;

}

export interface IDadosLiga {

    codigo: number;
    liga: string;
    nomeFranquia: string;
    classificacao: number;
    conferencia: string;
    imagem: string;
    estatisticas: [{
        ranking: number;
        foto: string;
        nomeJogador: string;
        posicao: string;
        franquiaJogador: string;
        stats: [{
            codigo: number;
            descricao: string;
            valor: number;
        }]
        pontuacao: number;
    }]

}

export interface IDadosRetornoLiga {
    dado: IDadosLiga;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IDadosLigaCard {

    codigo: number;
    nome: string;
    nomeFranquia: string;
    classificacao: number;
    conferencia: string;
    restrito: boolean;
    status: number;
    logo: string;
    caminho_Logo: string;
}

export interface IDadosMetodo {

    codigo: number;
    nomeStats: string;
    stats: number;
    peso: number;
    somatoria: boolean;
    positiva: boolean;
}


export interface IDadosEmpate {

    ordem: number;
    stats: number;
    setimo_Homem: boolean;
    oitavo_Homem: boolean;
    nono_Homem: boolean;
    decimo_Homem: boolean;

}


export interface IDadoDraftSim {

    codigo?: number;
    minimo: string;
    maximo: string;
    desconto: string;

}


export interface IDadosDraftNao {
    codigo?: number;
    escolha_Inicial: number;
    rodada: number;
    escolha_Rodada: number;
    posicao_Geral: number;
    salario: number;
    tempo_Contrato: number;
    restrito?: boolean;

}

export interface IDadosDraftInicial {
    codigo: number;
    escolha_Inicial: number;
    rodada: number;
    escolha_Rodada: string;
    escolha_Espelhada: string;
    escolha_Geral: string;
    salario: string;
    tempo_Contrato: string;
    codigo_Jogador: number;
    restrito: boolean;
}

export interface IDadosComissarios {
    nome: string;
    email: string;
    codigo_Usuario: number;
    criador: boolean;
}


export interface IDadosGeneralManager {
    nome: string;
    email: string;
    codigo_Usuario: number;
    criador: boolean;
}

export interface IDadosRegraDesempate {
    codigo?: number;
    nomeRegra: string;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    codigo_Criterio_Desempate: number;
    ordem: number;
    codUsuCriacao?: number;
    dtCriacao?: string;

}

export interface IDadosRegraDesempateGrid {

    codigo: number;
    ordem: number;
    nomeRegra: string;    
}

export interface IDetalheLiga {

    codigo: number;
    nome: string;
    dtCriacao: string;
    logo: string;
    quantidade_Franquia: number;
    restrito: boolean;
    status: number;
    nomeFranquia: string;
    classificacao: number;
    conferencia: string;
    imagem: string;
    comissario: boolean;
    codUsuCriacao: number;
}

export interface IDadosRetornoTodasLigas {
    dado: IDetalheLiga[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IListagemLigas {
    codigo: number;
    nome: string;
    dtCriacao: string;
    logo: string;
    caminho_Logo: string;
    quantidade_Franquia: number;
    codigo_Temporada: number;
    restrito: boolean;
    status: number;
    nome_Franquia: string;
    codigo_Franquia: number;
    codigo_Free_Agency: number;
    codigo_Leilao: number;
    rodada_Leilao: number;
    classificacao_Franquia: number;
    conferencia_Franquia: string;
    imagem: string;
    comissario_Usuario: boolean;
    codUsuCriacao: number;
    divisao_Franquia: string;
    separar_Multa_Temporada: number;
    abertura_Leilao: boolean;
    abertura_Free_Agency: boolean;
    nome_Usuario: string;
    abertura_Mercado: boolean;
    two_Way: boolean;
    abertura_Draft: boolean;
    abertura_Draft_Inicial: boolean;
    sem_Relogio_Calouro: boolean;
    data_Abertura_Calouro: Date;
    data_Encerramento_Calouro: Date;
    tempo_Escolha_Calouro: number;
    periodo_Util_Inicial_Calouro: string;
    periodo_Util_Final_Calouro: string;
    codigo_Tipo_Posicao_Confronto: number;
    sem_Relogio_Inicial: boolean;
    data_Abertura_Inicial: Date;
    data_Encerramento_Inicial: Date;
    tempo_Escolha_Inicial: number;
    periodo_Util_Inicio_Inicial: string;
    periodo_Util_Final_Inicial: string;
    abertura_Troca_Posicao: boolean;
    dentro_Periodo_Util: boolean;
    salarios_Reais_NBA: boolean;
    tipo_Free_Agency: number;
    tipo_Contrato_Ajustavel: number;
    porcentagem_Contrato_Ajustavel: string;
    primeira_Temporada: boolean;
    quantidade_Rodada: number;
    codigo_Tipo_Pontuacao: number;
    data_Sorteio_Copinha: Date;
    copinha_Sorteada: boolean;
    aceita_Empate: boolean;
    play_In: boolean;
}

export interface IDadosRetornoEdicao {
    dado: IDadosSaveLiga;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface ILstDrafSalario {
    escolha: number;
    rodada: number;
    porcentagem: number;
}

export interface IDadosRetornoDrafSalario {
    dado: ILstDrafSalario[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoLista {
    dado: IListagemLigas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IDadosRetornoCodigoLiga {
    dado: IListagemLigas;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

type TLigasComTotalCount = {
    data: IDadosRetornoLista;
    totalCount: number;
}

export interface IDadosRetornoLigaCards {
    dado: IDadosRespLogo;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}



type TLigasComTotalCountCardsDashboard = {
    data: IDadosRetornoCardLigas;
    totalCountCards: number;
}

// export interface IDadosRetornoLigasDashboard {
//     dado: IDadosRetornoCardLigas;
//     erros: string;
//     mensagem: string;
//     processado: boolean;
//     status: number;
//     statusHTTP: number;
// }


export interface IDadosRetornoCardLigas {
    dado: IDadosLigaCard[];
    erros: string[];
    mensagem: string;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetornoLigas {
    dado: IListagemLigas[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetorno {
    data: IDadosRetornoCardLigas;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosLogo {
    imageFile: File | null;
    Imagem: string;
    SrcImagem: string | ArrayBuffer | null | undefined;
}

export interface IDadosRetornoLogo {
    data: {
        dado: IDadosRespLogo;
        erros: string;
        mensagem: string;
        processado: boolean;
        status: number;
        statusHTTP: number;
    }
}

export interface IDadosRetornoSalvar {
    dado: number;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}


export interface IDadosRespLogo {
    caminho: string;
    nome: string;
    nomeReal: string;
}


export interface IDadosDraftCalouros {

    //codigo: number;
    pick: number;
    restrito: boolean;
    ano1: number;
    ano2: number;
    ano3: number;
    ano4: number;
    ano5: number;

}

export interface IDadosDuracao {

    codigo: number;
    tempo_Maximo: number;
    tempo_Minimo: number;
    valor_Maximo: number;
    valor_Minimo: number;
    permite_Ano_Adicional: boolean;

}


// export interface IDadosIntervaloLance {

//     codigo?: number;    
//     aumento_Minimo_Lance: number;
//     valor_Maximo: number;
//     valor_Minimo: number;

// }

// export interface IDadosTempoPeriodo {

//     codigo?: number;    
//     aumento_Minimo_Periodo: number;
//     valor_Maximo: number;
//     valor_Minimo: number;

// }

export interface IDadosJogadoresDraft {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    primeiro_Nome: string;
    ultimo_Nome: string;
    situacao: number;
    ativo: boolean;
    ano_Inicio: string;
    ano_Fim: string;
    codigo_Franquia_Atual: number;
    franquia_Atual: string;
    sigla_Franquia_Atual: string;
    cidade_Franquia_Atual: string;
    games_Played_Flag: string;
    other_League_Experience: string;
    foto: string;
    posicao: string;
    codUsuCriacao: number;
}

export interface IDadosRetornoPosicaoConversao {
    dado: IDadosPosicaoConversao[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosPosicaoConversao {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    posicao_Liga: string;
    posicao_Original: string;

}

export interface IDadosRetornoJogosNba {
    dado: IDadosJogosNba[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosJogosNba {
    codigo: number;
    codigo_NBA: number;
    codigo_Franquia_NBA_Mandante: string;
    nome_Franquia_NBA_Mandante: string;
    sigla_Franquia_NBA_Mandante: string;
    logo_Franquia_NBA_Mandante: string;
    codigo_Franquia_NBA_Visitante: string;
    nome_Franquia_NBA_Visitante: string;
    sigla_Franquia_NBA_Visitante: string;
    logo_Franquia_NBA_Visitante: string;
    data_Inicio: Date;
    codigo_Temporada: string;
    codUsuCriacao: number;
    mandante_Valido: boolean;
    visitante_Valido: boolean;
    ano_Inicio: string;
    ano_Fim: string;
    dtCriacao: Date;
    rodada_Iniciada: boolean;
    placar_Mandante: number;
    placar_Visitante: number;
}

export interface IDadosRetornoHistoricoLiga {
    dado: IDadosTodosHistoricosLigaResposta[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosTodosHistoricosLigaResposta {
    codigo_Tipo_Historico: number;
    data_Historico: Date;
    free_Agency_Lance: IListaDadosHistoricoFreeAgency;
    leilao_Lance: IListaDadosHistoricoLeilao;
    proposta: IDetalhePropostas;
    dispensa: IDadosHitoricoDispensa;
    historico_Ultimos_Confrontos: IDadosUltimasRodadas
}

export interface IDadosHitoricoDispensa {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    primeiro_Nome: string;
    ultimo_Nome: string;
    foto: string;
    nome_Franquia: string;
    logo_Franquia: string;
    data_Saida_Franquia: Date;
    codigo_Temporada_Saida_Franquia: number;

}

export interface IDadosRetornoUltimasRodadas {
    dado: IDadosUltimasRodadas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IDadosUltimasRodadas {
    codigo: number;
    rodada: number;
    codigo_Franquia_Mandante: number;
    codigo_Franquia_Visitante: number;
    placar_Franquia_Mandante: number;
    placar_Franquia_Visitante: number;
    nome_Franquia_Mandante: string;
    sigla_Franquia_Mandante: string;
    logo_Franquia_Mandante: string;
    nome_Franquia_Visitante: string;
    sigla_Franquia_Visitante: string;
    logo_Franquia_Visitante: string;
    vencedor_Franquia_Mandante: boolean;
    vencedor_Franquia_Visitante: boolean;
    empate: boolean;
    vencedor: boolean;
    perdedor: boolean;
    codigo_Status_Jogo: number;
    data_Limite_Escalacao: Date;
    dtCriacao: Date;
    numero: number;
    tipo: number;
    playOff: boolean;
}


export interface IDadosRetornoListao {
    dado: IDadosListao;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosListao {
    codigo_Temporada1: number;
    descricao_Temporada1: string;
    codigo_Temporada2: number;
    descricao_Temporada2: string;
    codigo_Temporada3: number;
    descricao_Temporada3: string;
    codigo_Temporada4: number;
    descricao_Temporada4: string;
    codigo_Temporada5: number;
    descricao_Temporada5: string;
    detalhes_Franquia: IDadosListaFranquiaLiga[]
}

export interface IDadosListaFranquiaLiga {
    codigo: number;
    nome: string;
    logo: string;
    caminho_Logo: string;
    nome_Usuario: string;
    foto_Usuario: string;
    caminho_Foto_Usuario: string;
    jogadores: IDadosListaJogadores[];
}

export interface IDadosListaJogadores {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto: string;
    codigo_Temporada_Calouro: number;
    posicao_1: string;
    posicao_2: string;
    posicao_3: string;
    salario_Ano1: string;
    salario_Ano2: string;
    salario_Ano3: string;
    salario_Ano4: string;
    salario_Ano5: string;
    tipo_Salario_1: number;
    tipo_Salario_2?: number;
    tipo_Salario_3?: number;
    tipo_Salario_4?: number;
    tipo_Salario_5?: number;
    contundido: boolean;
    dtContusao: Date;
    dtRetorno_Contusao: Date;
    draftado: boolean;
    fora_NBA: boolean;
    restrito: boolean;
}


export interface IDadosRetornoJogosPlayOffs {
    dado: IListagemConfrontosPlayOffs[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}


export interface IListagemConfrontosPlayOffs {
    codigo: number;
    codigo_Liga?: number;
    codigo_Status: number;
    codigo_Temporada?: number;
    codigo_Franquia_Mandante: number;
    codigo_Franquia_Visitante: number;
    placar_Franquia_Mandante: number;
    placar_Franquia_Visitante: number;
    nome_Franquia_Mandante: string;
    logo_Franquia_Mandante: string;
    nome_Franquia_Visitante: string;
    logo_Franquia_Visitante: string;
    vencedor_Franquia_Mandante: boolean;
    vencedor_Franquia_Visitante: boolean;
    empate: boolean;
    vencedor: boolean;
    perdedor: boolean;
    codigo_Status_Jogo: number;
    dtCriacao: Date;
    tipo: number;
    codigo_Conferencia: number;
    nome_Conferencia: string;
    copinha: boolean;
    calendario?: IListagemJogosPlayOffs[]
}

export interface IListagemJogosPlayOffs {
    codigo: number;
    codigo_Liga?: number;
    codigo_Status: number;
    codigo_Temporada?: number;
    codigo_Franquia_Mandante: number;
    codigo_Franquia_Visitante: number;
    placar_Franquia_Mandante: number;
    placar_Franquia_Visitante: number;
    nome_Franquia_Mandante: string;
    logo_Franquia_Mandante: string;
    nome_Franquia_Visitante: string;
    logo_Franquia_Visitante: string;
    vencedor_Mandante: boolean;
    vencedor_Visitante: boolean;
    empate: boolean;
    vencedor: boolean;
    numero: number;
    perdedor: boolean;
    status_Jogo: boolean;
    data_Limite_Escalacao: Date;
    dtCriacao: Date;
}

export interface IDadosRetornoJogosPlayOffsCopinha {
    dado: IListagemConfrontosPlayOffs[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

export interface IListagemConfrontosPlayOffsCopinha {
    codigo: number;
    codigo_Liga?: number;
    codigo_Status: number;
    codigo_Temporada?: number;
    codigo_Franquia_Mandante: number;
    codigo_Franquia_Visitante: number;
    placar_Mandante: number;
    placar_Visitante: number;
    nome_Franquia_Mandante: string;
    logo_Franquia_Mandante: string;
    nome_Franquia_Visitante: string;
    logo_Franquia_Visitante: string;
    vencedor_Franquia_Mandante: boolean;
    vencedor_Franquia_Visitante: boolean;
    empate: boolean;
    vencedor: boolean;
    perdedor: boolean;
    codigo_Status_Jogo: number;
    dtCriacao: Date;
    tipo_Copinha: number; 
    rodada: number;  
}



const getAllLigasDashboard = async (page = 1, filter = '', id = 0): Promise<TLigasComTotalCountCardsDashboard> => {

    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    // let codigoUsuario = user.codUsuario;
    // if (user.administrador) {
    //     codigoUsuario = localStorage.getItem("@codigoUsuFranquia");
    // }
    const { data, headers } = await Api.get(`/liga/usuario/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: filter
        }
    });
    return {
        data,
        totalCountCards: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    }
}

const getAll = async (page = 1, filter = '', id = 0): Promise<IDadosRetornoLista> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/liga/sql`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: id > 0 ? id : null,
            NumeroPagina: page,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: filter
        }
    });

    return data;
    //     data: {
    //         dado: [
    //             {
    //                 codigo: 1,
    //                 liga: "Liga 1",
    //                 nomeFranquia: "Mudado",
    //                 classificacao: 1,
    //                 conferencia: "NBA",
    //                 imagem: "https://cdn.nba.com/headshots/nba/latest/1040x760/1630583.png"
    //             },
    //             {
    //                 codigo: 2,
    //                 liga: "Liga 2",
    //                 nomeFranquia: "Peterson",
    //                 classificacao: 3,
    //                 conferencia: "NBA",
    //                 imagem: "https://cdn.nba.com/headshots/nba/latest/1040x760/203500.png"
    //             },
    //             {
    //                 codigo: 3,
    //                 liga: "Liga 3",
    //                 nomeFranquia: "Giancotti",
    //                 classificacao: 1,
    //                 conferencia: "NBA",
    //                 imagem: "https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    //             }
    //             ,
    //             {
    //                 codigo: 4,
    //                 liga: "Liga 4",
    //                 nomeFranquia: "Marco",
    //                 classificacao: 1,
    //                 conferencia: "NBA",
    //                 imagem: "https://cdn.nba.com/headshots/nba/latest/1040x760/203935.png"
    //             }
    //         ]
    //     }
    // }

    // return result;

}

const getAllLigas = async (): Promise<IDadosRetornoTodasLigas> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/liga`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;


}

const getAllPorUsuario = async (): Promise<TLigasComTotalCount> => {
    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    let codigoUsuario = user.codUsuario;

    // if (user.administrador) {
    //     codigoUsuario = localStorage.getItem("@codigoUsuFranquia");
    // }
    const { data, headers } = await Api.get(`/liga/usuario/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    }
}

const getAllPorCodigoUsuario = async (codigoUsuario: number): Promise<TLigasComTotalCount> => {
    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    
    const { data, headers } = await Api.get(`/liga/usuario/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    }
}

const getAllPorUsuarioAdm = async (): Promise<TLigasComTotalCount> => {
    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data, headers } = await Api.get(`/liga/usuario/administrador/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    }
}

const getDadosLigaPeloCodigo = async (codigo: number): Promise<IDadosRetornoCodigoLiga> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    let codigoUsuario = user.codUsuario;
    if (user.administrador && user.pagamentoConcluido) {
        codigoUsuario = localStorage.getItem("@codigoUsuFranquia");
    }
    if (codigoUsuario === "0") {
        codigoUsuario = user.codUsuario;
    }

    const { data } = await Api.get(`/liga/resumido/${codigo}/${codigoUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const getDadosLigaPeloCodigoTemporada = async (codigo: number, codigoTemporada: number): Promise<IDadosRetornoEdicao> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const getDadosListaoPorCodigoLiga = async (codigo = 0): Promise<IDadosRetornoListao> => {

    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/listao/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data

}


const getJogosNBAPorLigaTemporadaRodada = async (codigoLiga: number, codigoTemporada: number, rodada: number, codigoCalendario: number): Promise<IDadosRetornoJogosNba> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/jogos/nba/${codigoLiga}/${codigoTemporada}/${rodada}/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data

}

const getJogosNBAPorLigaTemporadaPlayOffs = async (codigoCalendario: number): Promise<IDadosRetornoJogosNba> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/jogos/nba/playoffs/${codigoCalendario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data

}

const getDadosPosicaoConversaoPorLiga = async (codigo = 0, codigoTemporada: number): Promise<IDadosRetornoPosicaoConversao> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoPosicaoConversao>(`/liga/posicao/${codigo}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const getDraftPorcentagemSalario = async (qtdrodada: number, qtdfranquia: number): Promise<IDadosRetornoDrafSalario> => {
    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/draft/salario/${qtdrodada}/${qtdfranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getById = async (codigo: number): Promise<IDadosRetornoEdicao> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoEdicao>(`/liga/completo/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getByIdUsuario = async (codigo: number): Promise<IDadosRetornoLiga> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoLiga>(`/liga/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getTodosHistoricosLiga = async (codigoLiga: number, codigoFranquia: number): Promise<IDadosRetornoHistoricoLiga> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoHistoricoLiga>(`/liga/historico/todos/${codigoLiga}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getHistoricosLigaResumido = async (codigoLiga: number, codigoFranquia: number): Promise<IDadosRetornoHistoricoLiga> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoHistoricoLiga>(`/liga/historico/resumido/${codigoLiga}/${codigoFranquia}/20`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getDadosUltimasRodadas = async (codigoLiga: number, codigoTemporada: number, rodada: number): Promise<IDadosRetornoUltimasRodadas> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get(`/liga/jogos/nba/${codigoLiga}/${codigoTemporada}/${rodada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data

}


const Create = async (dados: Omit<IDadosSaveLiga, "codigo">): Promise<IDadosRetornoSalvar> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/liga`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateById = async (dados: IDadosSaveLiga): Promise<void> => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");
    //dados.codUsuModificacao = user.codUsuario;
    return await Api.put(`/liga`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

}

const deleteById = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");
    const user = CookieService.get("access_user");
    return await Api.delete(`/liga/${codigo}/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const upLoadImage = async (image: any): Promise<IDadosRetornoLogo> => {

    // const obj = CookieService.get("access_user");
    // const idUsuario = obj.codUsuario;

    const formData = new FormData();
    formData.append('img', image);

    const token = CookieService.get("access_token");
    return await Api.post('/FileUpload/liga/logo/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'chavesessao': token
        }
    }).then(res => res)
        .catch((error) => error.response);
}


//#region Play Offs
const getConfrontosPlayOffs = async (codigoLiga: number = 0, codigoTemporada: number): Promise<IDadosRetornoJogosPlayOffs> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoJogosPlayOffs>(`/liga/confronto/playoffs/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}


const getConfrontosPlayOffsCopinha = async (codigoLiga: number = 0, codigoTemporada: number): Promise<IDadosRetornoJogosPlayOffsCopinha> => {
    //const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");

    const { data } = await Api.get<IDadosRetornoJogosPlayOffsCopinha>(`/liga/confronto/playoffs/copinha/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}
//#endregion


const getDadosMovimentacoesPorFiltros = async (codigo_Liga: number, codigoTemporada: number, codigoFranquia: number = 0, codigoJogador: number = 0): Promise<IDadosRetornoHistoricoLiga> => {
    const token = CookieService.get("access_token");

    const { data, headers } = await Api.get<IDadosRetornoHistoricoLiga>(`liga/movimentacoes`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigo_Liga,
            Codigo_Temporada: codigoTemporada === 0 ? null : codigoTemporada,
            Codigo_Franquia: codigoFranquia === 0 ? null : codigoFranquia,
            codigo_Jogador: codigoJogador === 0 ? null : codigoJogador
        }
    });

    return data;
}


const updateByIdVirarTemporadaLiga = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");

    const user = CookieService.get("access_user");
    //dados.codUsuModificacao = user.codUsuario;
    return await Api.put(`/liga/temporada/finalizar/${codigo}`, null, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

}


export const LigaService = {

    getAll,
    getAllLigas,
    getAllPorUsuario,
    getAllLigasDashboard,
    getById,
    getByIdUsuario,
    Create,
    updateById,
    deleteById,
    upLoadImage,
    getDraftPorcentagemSalario,
    getDadosLigaPeloCodigo,
    getDadosPosicaoConversaoPorLiga,
    getJogosNBAPorLigaTemporadaRodada,
    getAllPorUsuarioAdm,
    getTodosHistoricosLiga,
    getDadosUltimasRodadas,
    getDadosListaoPorCodigoLiga,
    getConfrontosPlayOffs,
    getJogosNBAPorLigaTemporadaPlayOffs,
    getDadosMovimentacoesPorFiltros,
    getHistoricosLigaResumido,
    updateByIdVirarTemporadaLiga,
    getDadosLigaPeloCodigoTemporada,
    getConfrontosPlayOffsCopinha,
    getAllPorCodigoUsuario
}

